import { makeStyles } from '@material-ui/core/styles';

import type { CustomTheme, Colors } from 'theme';

const useStyles = makeStyles((theme: CustomTheme) => ({
  header: {
    whiteSpace: 'pre-line',
    marginBottom: theme.spacing(1), // 8px
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  validationListItemDense: {
    paddingTop: theme.spacing(0), // 0px
    paddingBottom: theme.spacing(0), // 0px
  },
  validationListItemGutters: {
    paddingLeft: theme.spacing(1), // 8px
  },
  validationListItemIcon: {
    minWidth: theme.spacing(4), // 32px (24px icon + 8px right side spacing)
  },
  validationListItemInfoIcon: {
    color: theme.custom && (theme.custom?.colors as Colors).chart3Queued,
  },
  validationListItemCheckIcon: {
    color:
      theme.custom && (theme.custom?.colors as Colors).chart4WaitingForUser,
  },
}));

export default useStyles;
